import { render, staticRenderFns } from "./ExtraOptionsModule.vue?vue&type=template&id=4535456e&"
import script from "./ExtraOptionsModule.vue?vue&type=script&lang=ts&"
export * from "./ExtraOptionsModule.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraOptionsModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports